import { createIcon } from "@chakra-ui/react";

const PriorityIcon = createIcon({
  displayName: "PriorityIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      d="M9.41419 3.91089C7.47387 3.91089 6.44924 4.47261 5.74467 4.86424C5.62245 4.93218 5.52742 4.98484 5.43918 5.02896L4.99996 5.24857L4.99976 20.4644H6.58888L6.58888 12.9372C7.05269 12.8076 7.8403 12.6573 8.89768 12.6573C9.74347 12.6573 10.5015 12.9714 11.4287 13.3687L11.4814 13.3913C12.3531 13.7651 13.3874 14.2086 14.5857 14.2086C16.526 14.2086 17.5507 13.6469 18.2552 13.2553C18.3775 13.1873 18.4725 13.1347 18.5607 13.0906L19 12.8709L18.9994 4.45401L17.8495 5.02896C17.6422 5.13262 16.6679 5.46217 15.1022 5.46217C14.2564 5.46217 13.4984 5.14815 12.5712 4.75078L12.5186 4.7282C11.6468 4.3544 10.6126 3.91089 9.41419 3.91089Z"
      fill="currentColor"
    />
  ),
});

export default PriorityIcon;
